import { EllipsedText, FlexColumn, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { Cell, Grid } from 'baseui/layout-grid';
import { ParagraphSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';
import { JobCore } from '../../types/jobs';

type Props = {
  job: JobCore;
};
export function JobDetailData({ job }: Readonly<Props>) {
  const { theme } = useStyles();
  const { formatDateFromTs } = useMoment();
  const labelWidth = '80px';

  return (
    <Grid
      gridColumns={12}
      gridGaps={[8]}
      gridGutters={[30]}
      gridMargins={[0]}
      behavior="fluid"
    >
      <Cell span={[12, 12, 12, 6, 6]}>
        <FlexColumn gap={0}>
          <LabeledData
            label={'Descripción:'}
            content={
              <ParagraphSmall
                margin={0}
                color={theme.colors.contentSecondary}
              >
                <EllipsedText maxLines={0}>{job.description}</EllipsedText>
              </ParagraphSmall>
            }
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Tipo:'}
            content={job.jobType.name || '-'}
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Precio:'}
            content={job.price ? `$${Intl.NumberFormat().format(job.price)}` : '-'}
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Compañia:'}
            content={job.tenant?.name || '-'}
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Fecha programada:'}
            content={job.scheduleDate ? formatDateFromTs(job.scheduleDate, 'DD/MM/yyyy HH:mm:ss') : 'Sin fecha'}
            labelWidth={labelWidth}
          />
        </FlexColumn>
      </Cell>
      <Cell span={[12, 12, 12, 6, 6]}>
        <FlexColumn gap={0}>
          <LabeledData
            label={'Dirección:'}
            content={
              <ParagraphSmall
                margin={0}
                color={theme.colors.contentSecondary}
              >
                <EllipsedText maxLines={0}>{job.geocode || '-'}</EllipsedText>
              </ParagraphSmall>
            }
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Latitud:'}
            content={job.latitude ? job.latitude.toString() : '-'}
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Longitud:'}
            content={job.longitude ? job.longitude.toString() : '-'}
            labelWidth={labelWidth}
          />
        </FlexColumn>
      </Cell>
    </Grid>
  );
}
